import { makeStyles, Theme } from "@material-ui/core";
import {
  h2,
  h4Medium,
  h5Semibold,
  h5Medium,
  h6Regular,
  h6Semibold,
  h3,
  h7Medium,
  h6Medium,
  h7Regular,
} from "../../shared/typography";
import { pointer } from "../../shared/mixins";

export interface OrdersDetailsStyleProps {
  dir: "rtl" | "ltr";
}

export const useStyles = makeStyles<Theme, OrdersDetailsStyleProps>(
  (theme) => ({
    OrderDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 40,
      paddingTop: 16,
      "@media (max-width: 940px)": {
        padding: "40px 16px 0px 16px",
        gap: 16,
      },
    },
    OrderDetailsGoBack: (props) => ({
      ...h5Semibold,
      color: "#80BB34",
      display: "flex",
      alignItems: "center",
      gap: 16,
      ...pointer,
      flexDirection: props.dir === "ltr" ? "row" : "row-reverse",
      "@media (max-width: 940px)": {
        gap: 8,
        ...h7Medium,
      },
    }),
    goBackIcon: {
      "@media (max-width: 940px)": {
        width: 12,
        height: 12,
      },
    },
    OrderDetailsID: {
      padding: 0,
      margin: 0,
      ...h2,
      "@media (max-width: 940px)": {
        ...h3,
      },
    },
    orderDetailsIDContainer: {
      display: "flex",
      alignItems: "center",
      gap: 24,
      "@media (max-width:940px)": {
        justifyContent: "space-between",
        paddingTop: 24,
      },
    },
    subContainer: {
      display: "flex",
      gap: 40,
      alignItems: "flex-start",

      "@media (max-width: 940px)": {
        flexDirection: "column",
        gap: 16,
      },
    },

    deliveriesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 24,
      flex: 1,
      maxWidth: 760,

      "@media (max-width: 940px)": {
        maxWidth: "100%",
        width: "100%",
        gap: 16,
      },
    },
    deliveriesContainerDividerRes: {
      display: "none",
      "@media (max-width: 940px)": {
        display: "flex",
        width: "100%",
        height: 1,
        borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
      },
    },
    sideColumn: {
      width: 320,

      "@media (max-width: 940px)": {
        width: "100%",
      },
    },
    deliveryTo: {
      display: "flex",
      flexDirection: "column",
      gap: 24,
      padding: "40px 0",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",

      "@media (max-width: 940px)": {
        padding: "0 24px 16px 24px",
        gap: 16,
      },
    },

    deliveryToHeader: {
      display: "flex",
      gap: 16,
    },
    deliveryToText: {
      ...h5Medium,
      "@media (max-width: 940px)": {
        ...h6Medium,
      },
    },
    deliveryTruckIcon: {
      width: 24,
      height: 24,
      "@media (max-width: 940px)": {
        display: "none",
      },
    },
    customerDetails: {
      ...h6Regular,
      display: "flex",
      flexDirection: "column",
      "@media (max-width: 940px)": {
        ...h7Regular,
      },
    },
    actionItems: {
      padding: "40px 0",
      display: "flex",
      flexDirection: "column",
      gap: 24,
      "@media (max-width: 940px)": {
        padding: 0,
        gap: 8,
        marginTop: 16,
      },
    },
    copyOrderButton: {
      borderRadius: 16,
      background: "#80BB34",
      display: "flex",
      width: "100%",
      padding: "14px 16px 18px",
      justifyContent: "center",
      alignItems: "center",
      color: "#FFF",
      border: "none",
      ...h5Medium,
      ...pointer,
    },
    loaderContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
    cancelledMsgCard: {
      display: "flex",
      padding: "16px 24px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: 16,
      borderRadius: 16,
      background: "rgba(21, 34, 47, 0.08)",
      maxWidth: 660,
      width: "100%",
      boxSizing: "border-box",
      "@media (max-width: 940px)": {
        maxWidth: "100%",
        width: "100%",
      },
    },
    cancelledMsgHeader: {
      ...h6Semibold,
      color: "#15222F",
    },
    cancelledMsg: {
      ...h6Regular,
      color: "#15222F",
    },
    phoneNumber: (props) => ({
      direction: "ltr",
      display: "flex",
      justifyContent: props.dir === "ltr" ? "left" : "right",
    }),
    noOrderFound: {
      width: "100%",
      height: "90vh",
      display: "flex",
      flexDirection: "column",
      gap: 48,
      justifyContent: "center",
      alignItems: "center",
      ...h4Medium,
    },
  })
);
